(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    /**
     * Lookup for campaign communication message types
     * @constructor
     */
    window.Dashboard.Models.Lookups.CommunicationMessageTypes = {
        SMS: "SMS",
        PushNotification: "Push Notification"
    };
})();
